import React from 'react';
import { useFeatureGuard } from '../../graphql/community/hooks/useFeatureGuard';

export const FeatureGuard: React.FC<FeatureGuardProps> = ({
  features,
  children,
}) => {
  const { communityHasFeatures } = useFeatureGuard();
  return communityHasFeatures(...features) ? <>{children}</> : null;
};

export interface FeatureGuardProps {
  features: string[];
}
